module.exports = __webpack_public_path__ + "img/thumbnail_YellowAnaconda_u_albino.434a8b64.png";